module.exports = __webpack_public_path__ + "img/frank-trettin-avatar.2f8c4e5e.jpg";